/**
 * Derive the UI state for a printrun row.
 * The button rendered in the Past printruns list keys off this.
 *
 * Returns one of: 'rendering' | 'ready' | 'failed' | 'expired' | 'unknown'.
 */
export function printrunRowState(printrun) {
    if (printrun.pdf_deleted_at) return 'expired';
    switch (printrun.pdf_status) {
        case 'rendering': return 'rendering';
        case 'ready': return 'ready';
        case 'failed': return 'failed';
        default: return 'unknown';
    }
}
